import userRules from '../userRules'

export default [
  {
    path: '/p/s/turmas',
    icon: 'lni-school-bench-alt',
    name: 'Turmas',
    rule: userRules.STUDENT,
    submenu: [
      {
        path: '',
        name: 'StudentClass'
      },
      {
        path: '',
        name: 'StudentActivity'
      }
    ]
  }
]
